import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';

const ShopFooter = ({ organizationName, footer = {} }) => {
  const tagline = footer?.tagline;
  const contact = footer?.contact || {};
  const hasContact = contact.email || contact.phone || contact.address;
  const columns = (footer?.link_columns || []).filter((col) => (col.links || []).length > 0);

  return (
    <footer className="bg-white border-t border-slate-100 mt-12">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-10">
          <div className="col-span-2 sm:col-span-1 space-y-3">
            <span className="font-semibold text-slate-900">{organizationName}</span>
            {tagline && <p className="text-sm text-slate-500 leading-relaxed">{tagline}</p>}
            {hasContact && (
              <ul className="space-y-1.5 pt-1">
                {contact.email && (
                  <li className="flex items-center gap-2 text-sm text-slate-500">
                    <Mail className="w-3.5 h-3.5 shrink-0" />
                    <a href={`mailto:${contact.email}`} className="hover:text-teal-700">{contact.email}</a>
                  </li>
                )}
                {contact.phone && (
                  <li className="flex items-center gap-2 text-sm text-slate-500">
                    <Phone className="w-3.5 h-3.5 shrink-0" />
                    <a href={`tel:${contact.phone}`} className="hover:text-teal-700">{contact.phone}</a>
                  </li>
                )}
                {contact.address && (
                  <li className="flex items-start gap-2 text-sm text-slate-500">
                    <MapPin className="w-3.5 h-3.5 shrink-0 mt-0.5" />
                    <span>{contact.address}</span>
                  </li>
                )}
              </ul>
            )}
          </div>

          {columns.map((column, index) => (
            <div key={index} className="space-y-3">
              {column.title && <h3 className="text-sm font-semibold text-slate-900">{column.title}</h3>}
              <ul className="space-y-1.5">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a href={link.url || '#'} className="text-sm text-slate-500 hover:text-teal-700">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-400">
          <span>© {new Date().getFullYear()} {organizationName}</span>
          <span>Webshop mogelijk gemaakt door Zoea</span>
        </div>
      </div>
    </footer>
  );
};

export default ShopFooter;
